export interface IChooseActionForActivity {
    validate: boolean;
    toBeValidated: boolean;
    noComments: boolean;
};